import TopHeader from "./TopHeader";
import { Link } from "react-router-dom";
import Menus from "./Menus";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

export default function Header() {
  const { getText } = useLanguageTranslation();

  return (
    <>
      <header>
        <div className="logo-sec-wraper">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 logo-sec">
                <div className="rightbar">
                  <TopHeader />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-2 col-lg-4">
                <Link
                  className="logo-align"
                  to="/"
                  title={getText(
                    "A Wholly owned subsidiary of NTPC Limited",
                    "एनटीपीसी लिमिटेड की पूर्ण स्वामित्व वाली सहायक कंपनी",
                  )}
                >
                  <div className="brand-img">
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/logo1.png`}
                      alt="NEEPCO logo"
                      title="Neepco logo"
                    />
                  </div>
                  <div className="brand-text">
                    <span
                      className="main-txt-logo"
                      // style={{
                      //   fontWeight: languageType === "hi" ? "600" : "500",
                      // }}
                    >
                      {/* {getText("NEEPCO Ltd", "नीपको लिमिटेड ")} */}
                      {getText(
                        "North Eastern Electric Power Corporation Limited",
                        "नॉर्थ ईस्टर्न इलेक्ट्रिक पावर कॉरपोरेशन लिमिटेड",
                      )}
                    </span>
                    <span
                      className="gov-txt"
                      // style={{
                      //   fontWeight: languageType === "hi" ? "600" : "500", // bold if Hindi
                      // }}
                    >
                      {getText(
                        "A Government of India Enterprise",
                        "भारत सरकार का उद्यम",
                      )}
                    </span>
                    <span className="gov-txt2">
                      {getText(
                        "Schedule-A Miniratna Category-I PSU",
                        "अनुसूची-ए मिनीरत्‍न, श्रेणी-। पीएसयू",
                      )}
                    </span>
                    <span className="sub-sub-brand">
                      {getText(
                        "A wholly owned subsidiary of NTPC Limited",
                        "एनटीपीसी लिमिटेड की पूर्ण स्वामित्व वाली सहायक कंपनी",
                      )}
                    </span>
                  </div>
                </Link>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-8 main-menu-area">
                <Menus />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
